module.exports = __webpack_public_path__ + "img/yt-eth_usdc_slp.7510972b.svg";